import React, { CSSProperties, FC, ReactNode } from 'react'
import { ButtonProps } from 'antd'

import { ButtonDelete } from 'src/storybook/components/Buttons'

import { TFormVariant, useFormFnUIContext } from './FormUI'
import { Footer, TFooterProps } from '../antdform-kit-v2'

export type TFormFooterProps = Omit<TFooterProps, 'createMode'> & {
  style?: CSSProperties
  formStyle?: CSSProperties
  variant?: TFormVariant
  deleteHandler?: () => void
  deleteButtonProps?: ButtonProps
  action?: ReactNode
}

const variants = {
  basic: {
    padding: 0,
  },
  padded: {
    padding: 16,
  },
} as const

export const FormFooter: FC<TFormFooterProps> = ({
  deleteHandler,
  deleteButtonProps,
  variant: variantFromProps,
  style,
  formStyle,
  action,
  ...props
}) => {
  const {
    variant: variantFromContext,
    formId,
    createMode,
  } = useFormFnUIContext()

  const variant = variantFromProps ?? variantFromContext
  const variantProps = variants[variant]

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: deleteHandler ? 'space-between' : 'flex-end',
        width: '100%',
        padding: variantProps?.padding,
        ...style,
      }}
    >
      {action && action}
      {deleteHandler && !createMode && (
        <ButtonDelete {...deleteButtonProps} onClick={deleteHandler} />
      )}
      <Footer
        formId={formId}
        createMode={createMode}
        style={formStyle}
        {...props}
      />
    </div>
  )
}

export default FormFooter
